import React from 'react';
import { AlertTriangle } from 'lucide-react';

const UnassignedStudentsWidget = () => {
  return (
    <div className="text-center py-8">
      <AlertTriangle className="w-12 h-12 mx-auto mb-3 text-orange-500" />
      <p className="text-lg font-semibold text-gray-900">0 Unassigned Students</p>
      <p className="text-sm text-gray-600 mt-1">All students have batch assignments</p>
    </div>
  );
};

export default UnassignedStudentsWidget;